import { createFileRoute } from '@tanstack/react-router'
import { ComplianceControlDetailPage } from '../../../components/ComplianceControlDetailPage'

export const Route = createFileRoute('/$org/compliance-controls/$controlUid')({
  component: ComplianceControlDetail,
})

function ComplianceControlDetail() {
  return <ComplianceControlDetailPage />
}
